// extracted by mini-css-extract-plugin
export default {"formInput":"inputs_formInput__cUR0s","textArea":"inputs_textArea__CXUaV","inputRight":"inputs_inputRight__-tL7Q"};